/* eslint-disable no-new */

import Menu from '../components/menu/menu';
import Print from '../components/print/print';
import Notification from '../components/notification/notification';
import Gallery from '../components/gallery/light_gallery';
import share from '../components/share/share';
import '../components/animations/rotateOnScroll';
import '../components/animations/moveLeftRight';
import '../components/animations/clipParallax';
import '../components/cards/property';

const siteNavMenuOverlay = document.getElementById('site-nav-menu');
const notificationCloseButton = document.getElementById('notification-close-button');
const galleries = [];

if (siteNavMenuOverlay) {
  new Menu(siteNavMenuOverlay);
}

// Set the notification
if (notificationCloseButton) {
  new Notification(notificationCloseButton);
}

// opens the print dialog on click
document.querySelectorAll('.js-print').forEach((printBtn) => new Print(printBtn));

// init galleries
document.querySelectorAll('.js-gallery').forEach((gallery) => galleries.push(new Gallery(gallery)));

// prevent context menu on <img>
document.querySelectorAll('img').forEach((img) => img.addEventListener('contextmenu', (e) => {
  const exceptions = ['localhost', '.test'];
  if (!exceptions.some((exception) => window.location.hostname.includes(exception))) e.preventDefault();
}));

// trigger galleries
document.querySelectorAll('.js-trigger-gallery').forEach((trigger) => {
  // eslint-disable-next-line consistent-return
  trigger.addEventListener('click', () => {
    // no galleries found, do nothing
    if (galleries.length < 1) return false;

    // trigger first gallery
    galleries[0].lightGallery.openGallery(0);
  });
});

// share buttons
document.querySelectorAll('.js-share').forEach((shareEl) => shareEl.addEventListener('click', () => {
  share({
    title: shareEl.dataset.title,
    text: shareEl.dataset.text,
  });
}));

function requireAll(r) {
  r.keys().forEach(r);
}

// load all js files, but exclude those in partials
requireAll(require.context('./', true, /^(?!.*\/partials\/).*.js$/));
